'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index$1 = require('../hooks/useMediaQuery/index.js');
var index = require('../hooks/useWindowSize/index.js');
var _interface = require('../hooks/useWindowSize/interface.js');
var _interface$1 = require('./interface.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var QUERY_COLOR_SCHEME_DARK = '(prefers-color-scheme: dark)';
var QUERY_COLOR_SCHEME_LIGHT = '(prefers-color-scheme: light)';
var Theme = React.createContext({
  device: _interface.Vdevice.DESKTOP,
  lang: 'en',
  dir: _interface$1.Vdir.LTR,
  mode: _interface$1.Vmode.LIGHT,
  color: _interface$1.Vcolor.BLUE,
  sidebar: _interface$1.Vsidebar.SHOW,
  fontFamily: _interface$1.VfontFamily.DEFAULT,
  fontSize: _interface$1.VfontSize.DEFAULT,
  setDevice: null,
  setLang: null,
  setDir: null,
  setMode: null,
  setColor: null,
  setFontFamily: null,
  setFontSize: null,
  toggleMode: null,
  toggleSidebar: null
});
var useTheme = function () {
  return React.useContext(Theme);
};

function getMode() {
  if (window.matchMedia) {
    // wjdlz | NOTE: Check if the dark-mode Media-Query matches
    if (window.matchMedia(QUERY_COLOR_SCHEME_DARK).matches) {
      return _interface$1.Vmode.DARK;
    } else if (window.matchMedia(QUERY_COLOR_SCHEME_LIGHT).matches) {
      return _interface$1.Vmode.LIGHT;
    }
  } // wjdlz | NOTE: no-preference / hasNoSupport


  var hour = new Date().getHours();
  return hour < 6 || hour >= 18 ? _interface$1.Vmode.DARK : _interface$1.Vmode.LIGHT;
}

function getSidebarState() {
  return index.IsMobile() ? _interface$1.Vsidebar.HIDE : _interface$1.Vsidebar.SHOW;
}

var ThemeProvider = function (_a) {
  var children = _a.children;

  var _b = React.useState(index.GetDevice()),
      device = _b[0],
      setDevice = _b[1];

  var _c = React.useState('en'),
      lang = _c[0],
      setLang = _c[1];

  var _d = React.useState(_interface$1.Vdir.LTR),
      dir = _d[0],
      setDir = _d[1];

  var _e = React.useState(_interface$1.Vmode.SYSTEM),
      mode = _e[0],
      setMode = _e[1];

  var _f = React.useState(_interface$1.Vcolor.BLUE),
      color = _f[0],
      setColor = _f[1];

  var _g = React.useState(_interface$1.VfontFamily.DEFAULT),
      fontFamily = _g[0],
      setFontFamily = _g[1];

  var _h = React.useState(_interface$1.VfontSize.DEFAULT),
      fontSize = _h[0],
      setFontSize = _h[1];

  var _j = React.useState(getSidebarState()),
      sidebar = _j[0],
      setSidebar = _j[1];

  var vthemeAttr = {
    device: 'vdevice',
    lang: 'vlang',
    color: 'vcolor',
    fontFamily: 'vfont-family',
    fontSize: 'vfont-size',
    // wjdlz | NOTE: for custom data attr
    dir: 'vdir',
    mode: 'vmode',
    sidebar: 'vsidebar' // wjdlz | NOTE: based on | screen size, user preference

  };

  var getRoot = function () {
    var root = document.getElementsByTagName('html');
    return root[0];
  };

  var updateClass = function (key, value) {
    var dom = getRoot(),
        salt = "".concat(key, "-"),
        data = [];
    dom.classList.forEach(function (name) {
      if (name.startsWith(salt)) {
        data.push(name);
      }
    });
    data.forEach(function (val) {
      dom.classList.remove(val);
    });
    dom.classList.add(salt + value);
  };

  var updateAttribute = function (key, value) {
    getRoot().setAttribute(key, value);
  };

  React.useEffect(function () {
    updateClass(vthemeAttr.device, device);
  }, [device]);
  React.useEffect(function () {
    updateAttribute(vthemeAttr.lang, lang);
  }, [lang]);
  React.useEffect(function () {
    updateClass(vthemeAttr.dir, dir);
  }, [dir]);
  React.useEffect(function () {
    var parsedMode = mode;

    if (mode == _interface$1.Vmode.SYSTEM) {
      parsedMode = getMode();
    }

    updateMode(parsedMode); // updateAttribute("vdata-theme-mode", mode);
  }, [mode]);
  React.useEffect(function () {
    updateColor(color);
  }, [color]);
  React.useEffect(function () {
    updateClass(vthemeAttr.fontFamily, fontFamily);
  }, [fontFamily]);
  React.useEffect(function () {
    updateClass(vthemeAttr.fontSize, fontSize);
  }, [fontSize]);
  React.useEffect(function () {
    updateClass(vthemeAttr.sidebar, sidebar);
  }, [sidebar]); // wjdlz | NOTE: custom hooks

  var isDarkMode = index$1["default"](QUERY_COLOR_SCHEME_DARK);
  React.useEffect(function () {
    if (mode !== _interface$1.Vmode.SYSTEM) {
      return;
    }

    updateMode(getMode());
  }, [isDarkMode]);
  React.useEffect(function () {
    var handler = function () {
      if (sidebar == _interface$1.Vsidebar.SHOW) {
        if (index.IsMobile()) {
          setSidebar(_interface$1.Vsidebar.HIDE);
        }
      }
    };

    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [sidebar]);
  React.useEffect(function () {
    var handler = function () {
      setDevice(index.GetDevice());
    };

    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [device]); // wjdlz | NOTE: custom operations

  var updateMode = function (mode) {
    var light = 'hsl(0, 0%, 100%)'; // hsl(180, 5%, 95%) | wjdlz | NOTE: have to be in sync with variables.less

    var dark = 'hsl(0, 0%, 0%)'; // hsl(220, 5%, 20%) hsl(210, 6%, 13%)' || "hsl(0, 0%, 12%)";

    updateClass(vthemeAttr.mode, mode); // wjdlz | NOTE: to update PWA appheader

    document.querySelectorAll('meta[name=background-color]').forEach(function (el) {
      el.setAttribute('content', mode == _interface$1.Vmode.LIGHT ? light : dark);
    });
    document.querySelectorAll('meta[name=theme-color]').forEach(function (el) {
      el.setAttribute('content', mode == _interface$1.Vmode.LIGHT ? light : dark);
    });
  };

  var updateColor = function (color) {
    updateClass(vthemeAttr.color, color);
  };

  var toggleMode = function () {
    if (mode == _interface$1.Vmode.SYSTEM) {
      var parsedMode = _interface$1.Vmode.DARK;

      if (getRoot().className.includes("".concat(vthemeAttr.mode, "-").concat(_interface$1.Vmode.DARK))) {
        parsedMode = _interface$1.Vmode.LIGHT;
      }

      updateMode(parsedMode);
    } else {
      setMode(mode == _interface$1.Vmode.DARK ? _interface$1.Vmode.LIGHT : _interface$1.Vmode.DARK);
    }
  };

  var toggleSidebar = function () {
    setSidebar(sidebar == _interface$1.Vsidebar.SHOW ? _interface$1.Vsidebar.HIDE : _interface$1.Vsidebar.SHOW);
  };

  return React__default["default"].createElement(Theme.Provider, {
    value: {
      device: device,
      lang: lang,
      dir: dir,
      mode: mode,
      color: color,
      sidebar: sidebar,
      fontFamily: fontFamily,
      fontSize: fontSize,
      setDevice: setDevice,
      setLang: setLang,
      setDir: setDir,
      setMode: setMode,
      setColor: setColor,
      setFontFamily: setFontFamily,
      setFontSize: setFontSize,
      toggleMode: toggleMode,
      toggleSidebar: toggleSidebar
    }
  }, children);
};

exports.ThemeProvider = ThemeProvider;
exports.useTheme = useTheme;
